import { useEffect, useMemo } from "react";
import {
  ChakraBaseProvider,
  extendBaseTheme,
  useColorMode
} from "@chakra-ui/react";
import getNamedTheme from "src/styling/getNamedTheme";
import { components } from "./components";
import { semanticTokens } from "./semantic-tokens";
import { styles } from "./globalStyles";

function ChakraThemeupdater({ children, theme }) {
  const { setColorMode, colorMode } = useColorMode();

  useEffect(() => {
    if (theme.config.initialColorMode !== colorMode) {
      setColorMode(theme.config.initialColorMode);
    }
  }, [setColorMode, colorMode, theme]);

  return children;
}

export default function NamedThemeProvider({ themeName, children }) {
  const chakraTheme = useMemo(() => {
    const namedTheme = getNamedTheme(themeName);
    const theme = extendBaseTheme({
      styles,
      components,
      semanticTokens,
      colors: namedTheme.colors,
      breakpoints: namedTheme.breakpoints,
      fonts: namedTheme.fonts,
      config: {
        initialColorMode: namedTheme.isDarkMode ? "dark" : "light",
        useSystemColorMode: false
      }
    });

    return theme;
  }, [themeName]);

  return (
    <ChakraBaseProvider theme={chakraTheme}>
      <ChakraThemeupdater theme={chakraTheme}>{children}</ChakraThemeupdater>
    </ChakraBaseProvider>
  );
}
